<template>
    <div class="meal-scheduling-page">
        <div class="page-header">
            <el-select v-model="selectedDay" placeholder="选择日期">
                <el-option label="周一" value="周一"></el-option>
                <el-option label="周二" value="周二"></el-option>
                <el-option label="周三" value="周三"></el-option>
                <el-option label="周四" value="周四"></el-option>
                <el-option label="周五" value="周五"></el-option>
                <el-option label="周六" value="周六"></el-option>
                <el-option label="周日" value="周日"></el-option>
            </el-select>

            <div class="header-actions">
                <el-button type="success" @click="getDishByDate">生成订单</el-button>
                <el-button type="success" @click="saveSchedule">保存排菜</el-button>
            </div>
        </div>

        <!-- 拖拽区域 -->
        <div class="drag-container">
            <!-- 菜品库：展示合并后的成品菜+套餐 -->
            <div class="dish-library">
                <h3>菜品库（成品菜+套餐）</h3>
                <draggable :list="mergedDishList" :group="{ name: 'dish', pull: 'clone', put: false }"
                    :clone="cloneDish" animation="300" style="display: flex;width: 100%;flex-wrap: wrap;">
                    <div v-for="dish in mergedDishList" :key="dish.id" class="dish-item">
                        {{ dish.dishName || dish.name }}
                        <span class="dish-type">{{ dish.dishType || dish.type }}</span>
                    </div>
                </draggable>
            </div>

            <!-- 当日菜单 -->
            <div class="daily-menu">
                <h3>{{ selectedDay }} 菜单</h3>

                <div v-for="(meal, mealIndex) in currentDayMenu" :key="meal.id" class="meal-section">
                    <div class="meal-header">
                        <span class="meal-type">{{ meal.type }}</span>
                        <span class="meal-time">{{ meal.startTime }} - {{ meal.endTime }}</span>
                        <el-button type="text" size="mini" class="delete-meal" @click="removeMeal(mealIndex)">
                            删除
                        </el-button>
                    </div>

                    <draggable :list="meal.dish" :group="{ name: 'dish', pull: true, put: true }" animation="300"
                        @change="() => updateMealDish(mealIndex)" style="display: flex;width: 100%;flex-wrap: wrap;">
                        <div v-for="(dish, dishIndex) in meal.dish" :key="dish.id + '_' + dishIndex"
                            class="menu-dish-item">
                            {{ dish.dishName || dish.name }}
                            <el-button type="text" size="mini" icon="el-icon-delete"
                                @click.stop="removeDish(mealIndex, dishIndex)"></el-button>
                        </div>
                    </draggable>

                    <div v-if="meal.dish.length === 0" class="empty-dish-placeholder">
                        拖拽菜品到这里...
                    </div>
                </div>

                <div v-if="currentDayMenu.length === 0" class="empty-menu-placeholder">
                    暂无餐次，请先新增餐次
                </div>
            </div>
        </div>

        <!-- 新增/修改餐次弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
            <el-form :model="formData" ref="formRef" label-width="100px" :rules="formRules" :z-index="9999"
                append-to-body>
                <el-form-item label="餐次类型" prop="type">
                    <el-select v-model="formData.type" placeholder="请选择餐次类型">
                        <el-option label="早餐" value="早餐"></el-option>
                        <el-option label="午餐" value="午餐"></el-option>
                        <el-option label="晚餐" value="晚餐"></el-option>
                        <el-option label="加餐" value="加餐"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="开始时间" prop="startTime">
                    <el-time-picker v-model="formData.startTime" format="HH:mm" value-format="HH:mm"
                        placeholder="选择开始时间"></el-time-picker>
                </el-form-item>

                <el-form-item label="结束时间" prop="endTime">
                    <el-time-picker v-model="formData.endTime" format="HH:mm" value-format="HH:mm"
                        placeholder="选择结束时间"></el-time-picker>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitMealForm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getDishList, dishArrangement, getDishArrangementList, getDishByDate } from "@/api/planning";

export default {
    components: { draggable },
    data() {
        // 验证结束时间是否晚于开始时间
        const validateTime = (rule, value, callback) => {
            if (!this.formData.startTime || !this.formData.endTime) {
                return callback()
            }
            const start = new Date(`2000-01-01 ${this.formData.startTime}`).getTime()
            const end = new Date(`2000-01-01 ${this.formData.endTime}`).getTime()
            if (end <= start) {
                return callback(new Error('结束时间必须晚于开始时间'))
            }
            callback()
        }

        return {
            selectedDay: '', // 【修改1】初始化为空，后续赋值当前星期
            allDish: [], // 成品菜数组
            allDish1: [], // 套餐数组
            weeklyMenu: {
                周一: [],
                周二: [],
                周三: [],
                周四: [],
                周五: [],
                周六: [],
                周日: []
            },
            dialogVisible: false,
            dialogTitle: '新增餐次',
            formData: {
                type: '',
                startTime: '',
                endTime: ''
            },
            formRules: {
                type: [{ required: true, message: '请选择餐次类型', trigger: 'change' }],
                startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endTime: [
                    { required: true, message: '请选择结束时间', trigger: 'change' },
                    { validator: validateTime, trigger: 'change' }
                ]
            },
            currentEditMealIndex: -1
        }
    },
    computed: {
        currentDayMenu() {
            return this.weeklyMenu[this.selectedDay] || []
        },
        // 核心：合并成品菜和套餐数组（自动响应数据变化）
        mergedDishList() {
            // 合并两个数组，去重（避免ID重复），保留最新数据
            const allData = [...this.allDish, ...this.allDish1];
            // 去重逻辑：根据id去重，防止重复展示
            const uniqueData = Array.from(new Map(allData.map(item => [item.id, item])).values());
            return uniqueData;
        }
    },
    watch: {
        // 恢复切换日期自动加载
        selectedDay() {
            this.currentEditMealIndex = -1
            this.loadSavedSchedule()
        }
    },
    created() {
        // 【修改2】先获取当前星期并赋值，再加载数据
        this.setCurrentDay()
        // 并行加载两个菜品列表，确保数据都加载完成
        this.loadAllDishData()
        this.loadSavedSchedule()
    },
    methods: {
        // 【新增方法】获取当前实际星期并赋值给selectedDay
        setCurrentDay() {
            const weekMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            const now = new Date()
            const weekIndex = now.getDay() // 0=周日，1=周一...6=周六
            this.selectedDay = weekMap[weekIndex]
            console.log('当前实际星期：', this.selectedDay)
        },
        // 生成订单
        getDishByDate() {
            getDishByDate({ date: this.selectedDay, userId: localStorage.getItem('userId') }).then(response => {
                this.$message.success(response.data)
            })
        },
        // 并行加载成品菜和套餐数据，确保数据完整
        loadAllDishData() {
            Promise.all([this.getList(), this.getList1()])
                .then(() => {
                    console.log('成品菜和套餐数据加载完成，已合并');
                    console.log('合并后的数据：', this.mergedDishList);
                })
                .catch(err => {
                    console.error('菜品数据加载失败:', err);
                });
        },
        getList() {
            return getDishList({ userId: localStorage.getItem('userId'), type: '成品菜' }).then(response => {
                if (response.data && Array.isArray(response.data)) {
                    this.allDish = response.data.map(dish => ({
                        id: dish.id || Date.now() + Math.random(),
                        dishName: dish.dishName || dish.name,
                        dishType: dish.dishType || dish.type,
                        ...dish
                    }))
                }
            }).catch(err => {
                console.error('加载成品菜库失败:', err)
                this.$message.error('成品菜库加载失败，请刷新重试')
            })
        },
        getList1() {
            return getDishList({ userId: localStorage.getItem('userId'), type: '套餐' }).then(response => {
                if (response.data && Array.isArray(response.data)) {
                    this.allDish1 = response.data.map(dish => ({
                        id: dish.id || Date.now() + Math.random(),
                        dishName: dish.dishName || dish.name,
                        dishType: dish.dishType || dish.type,
                        ...dish
                    }))
                }
            }).catch(err => {
                console.error('加载套餐库失败:', err)
                this.$message.error('套餐库加载失败，请刷新重试')
            })
        },
        cloneDish(dish) {
            return {
                ...dish,
                id: Date.now() + Math.random()
            }
        },

        handleAddMeal() {
            this.dialogTitle = '新增餐次'
            this.currentEditMealIndex = -1
            this.formData = { type: '', startTime: '', endTime: '' }
            this.dialogVisible = true
        },

        editMeal(index) {
            this.dialogTitle = '编辑餐次'
            this.currentEditMealIndex = index
            const meal = this.currentDayMenu[index]
            this.formData = {
                type: meal.type,
                startTime: meal.startTime,
                endTime: meal.endTime
            }
            this.dialogVisible = true
        },

        submitMealForm() {
            this.$refs.formRef.validate((valid) => {
                if (!valid) return

                const mealData = {
                    id: Date.now().toString(),
                    type: this.formData.type,
                    startTime: this.formData.startTime,
                    endTime: this.formData.endTime,
                    dish: []
                }

                if (this.currentEditMealIndex === -1) {
                    this.weeklyMenu[this.selectedDay].push(mealData)
                    this.$message.success('新增餐次成功')
                } else {
                    this.weeklyMenu[this.selectedDay].splice(
                        this.currentEditMealIndex,
                        1,
                        { ...this.currentDayMenu[this.currentEditMealIndex], ...mealData }
                    )
                    this.$message.success('修改餐次成功')
                }

                this.dialogVisible = false
            })
        },

        removeMeal(index) {
            this.$confirm(`确定删除【${this.currentDayMenu[index].type}】吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                this.weeklyMenu[this.selectedDay].splice(index, 1)
                this.$message.success('餐次删除成功')
            })
        },

        removeDish(mealIndex, dishIndex) {
            this.currentDayMenu[mealIndex].dish.splice(dishIndex, 1)
        },

        updateMealDish(mealIndex) {
            console.log(`【${this.selectedDay}-${this.currentDayMenu[mealIndex].type}】菜品已更新`, this.currentDayMenu[mealIndex].dish)
        },

        saveSchedule() {
            const currentMeals = this.weeklyMenu[this.selectedDay] || [];

            const submitData = {
                userId: localStorage.getItem('userId'),
                date: this.selectedDay,
                dishArrangement: currentMeals.map(meal => ({
                    date: this.selectedDay,
                    mealPeriod: meal.type,
                    timePeriod: meal.startTime,
                    endTime: meal.endTime,
                    dish: JSON.stringify(meal.dish.map(dish => ({
                        dishName: dish.dishName,
                    })))
                }))
            };

            dishArrangement(submitData)
                .then(response => {
                    if (response.code === 200 || response.success) {
                        this.$message.success('排菜信息保存成功');
                        this.loadSavedSchedule()
                        console.log('后端返回数据:', response.data);
                    } else {
                        this.$message.error(`保存失败：${response.message || '未知错误'}`);
                    }
                })
                .catch(err => {
                    console.error('保存排菜失败:', err);
                    this.$message.error('网络异常，保存失败，请重试');
                });
        },

        // 核心修复：loadSavedSchedule 方法
        loadSavedSchedule() {
            // 若selectedDay为空（极端情况），先赋值当前星期
            if (!this.selectedDay) {
                this.setCurrentDay()
            }
            // 清空当前日期旧数据
            this.weeklyMenu[this.selectedDay] = [];

            getDishArrangementList({
                userId: localStorage.getItem('userId'),
                date: this.selectedDay
            }).then(res => {
                console.log('后端返回的排菜数据:', res.data);

                // 1. 校验基础格式：必须是数组且非空
                if (!res.data || !Array.isArray(res.data) || res.data.length === 0) {
                    this.$message.info(`暂无${this.selectedDay}的排菜数据`);
                    return;
                }

                // 2. 遍历后端返回的餐次数组（每个元素是一个餐次对象）
                const formattedMeals = res.data.map(meal => {
                    // 校验当前餐次对象的核心字段
                    if (!meal || typeof meal !== 'object' || !meal.mealPeriod || !meal.timePeriod) {
                        console.warn('无效的餐次数据:', meal);
                        return null; // 跳过无效数据
                    }

                    // 3. 拆分 timePeriod（如 "06:00-08:00" → startTime="06:00", endTime="08:00"）
                    const [startTime, endTime] = meal.timePeriod.split('-').map(time => time.trim());

                    // 4. 解析菜品数据（后端 dish 可能为 null 或 JSON 字符串）
                    let dishList = [];
                    if (meal.dish) {
                        try {
                            // 若 dish 是 JSON 字符串则解析，否则直接使用（如数组）
                            dishList = typeof meal.dish === 'string' ? JSON.parse(meal.dish) : meal.dish;
                        } catch (e) {
                            console.error('菜品数据解析失败:', e, '原始数据:', meal.dish);
                            dishList = [];
                        }
                    }

                    // 5. 标准化菜品数据格式
                    const formattedDishes = dishList.map(dish => ({
                        id: dish.id || Date.now() + Math.random().toString(36).substr(2, 9),
                        dishName: dish.dishName || dish.name || '未知菜品',
                        dishType: dish.dishType || dish.type || '未知类型',
                        ...dish
                    }));

                    // 6. 格式化餐次数据（适配前端模板字段）
                    return {
                        id: meal.id || Date.now().toString(), // 餐次ID（优先使用后端ID）
                        type: meal.mealPeriod, // 餐次类型（早餐/午餐等）
                        startTime: startTime || '', // 拆分后的开始时间
                        endTime: endTime || '', // 拆分后的结束时间
                        dish: formattedDishes // 格式化后的菜品数组
                    };
                }).filter(Boolean); // 过滤无效数据

                // 7. 将格式化后的餐次数组赋值到当前选中日期
                this.weeklyMenu[this.selectedDay] = formattedMeals;
                console.log(`已加载${this.selectedDay}的排菜数据:`, formattedMeals);

                this.$message.success(`${this.selectedDay}排菜数据加载成功`);
            }).catch(err => {
                console.error('加载排菜数据失败:', err);
                this.$message.error('排菜数据加载失败，请刷新重试');
            });
        }
    }
}
</script>

<style scoped>
.meal-scheduling-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
    box-sizing: border-box;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px 0;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.drag-container {
    display: flex;
    gap: 20px;
    height: 79vh;

}

.dish-library,
.daily-menu {
    flex: 1;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 15px;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.dish-library h3,
.daily-menu h3 {
    margin: 0 0 15px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    font-size: 16px;
    color: #333;
}

.dish-item {
    padding: 10px 15px;
    margin-bottom: 20px;
    background: #f0f7ff;
    border-radius: 4px;
    cursor: move;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    width: 29%;
    margin-right: 4.3%;
}

.dish-item:hover {
    background: #e6f7ff;
    transform: translateY(-2px);
    color: red;
}

.dish-type {
    font-size: 12px;
    color: #666;
    background: rgba(0, 0, 0, 0.05);
    padding: 2px 6px;
    border-radius: 12px;
}

.meal-section {
    margin-bottom: 20px;
    padding: 15px;
    background: #fafafa;
    border-radius: 6px;
    border: 1px solid #eee;
}

.meal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #eee;
}

.meal-type {
    font-weight: bold;
    font-size: 15px;
    color: #1890ff;
}

.meal-time {
    font-size: 12px;
    color: #666;
}

.delete-meal {
    color: #f56c6c;
}

.menu-dish-item {
    padding: 10px 15px;
    margin-bottom: 8px;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    cursor: move;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    color: #000;
    width: 29%;
    margin-right: 4.3%;
}

.menu-dish-item:hover {
    border-color: #1890ff;
    background: #f0f7ff;
    color: #000;
}

.empty-dish-placeholder {
    padding: 30px;
    text-align: center;
    color: #999;
    font-size: 14px;
    background: #fafafa;
    border: 1px dashed #ddd;
    border-radius: 4px;
}

.empty-menu-placeholder {
    padding: 60px;
    text-align: center;
    color: #999;
    font-size: 14px;
    background: #fafafa;
    border: 1px dashed #ddd;
    border-radius: 4px;
    margin-top: 15px;
}

::v-deep .ghost {
    opacity: 0.5;
    background: #1890ff;
    color: white;
}

::v-deep .dragging {
    opacity: 0.8;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>